export const getTitle = (source: string) => {
  if (source === 'refill') {
    return 'Пополнение счёта';
  }

  return 'Недостаточно средств.\nПополните счёт';
};
